export const AVAILABLE_LOCALES = ['en', 'de', 'ru', 'es', 'fr', 'it', 'pt', 'cs']

export const LOCALE_LABELS = {
    en: 'English',
    de: 'Deutsch',
    ru: 'Русский',
    es: 'Español',
    fr: 'Français',
    it: 'Italiano',
    pt: 'Português',
    cs: 'Čeština',
}

export const detectLocale = () => {
    const stored = localStorage.getItem('timebrella-locale')
    if (stored && AVAILABLE_LOCALES.includes(stored)) {
        return stored
    }
    const browserLang = navigator.language?.split('-')[0]
    if (browserLang && AVAILABLE_LOCALES.includes(browserLang)) {
        return browserLang
    }
    return 'en'
}
